import utils from '../apiCaller';

export const userLogin = (body) =>
{
	return utils.store('user/login', body);
};

export const userSignup = (body) =>
{
	return utils.store('user/add-user', body);
};

export const verifyToken = () =>
{
	const token = localStorage.getItem('userAuthToken');

	return utils.fetch(`user/getUserByToken/${token}`);
};

export const sendForgotLink = (body) =>
{
	return utils.store('user/forgot-password', body);
};

export const resetPassword = (body) =>
{
	return utils.store('user/reset-password', body);
};

export const usersList = (assignedTo) =>
{
	return utils.fetch(`user/usersList/${assignedTo}`);
};

export const editUser = (body) =>
{
	return utils.store('user/edit-user', body);
};

export const removeUser = (body) =>
{
	return utils.store('user/delete-user', body);
};

export const getMyPlans = () =>
{
	return utils.fetch('myplans');
};

export const getAddressBook = (searchKey='') =>
{
	let path = 'addressBook';

	path += searchKey !== '' ? `?searchKey=${searchKey}` : '';

	return utils.fetch(path);
};

export const saveAddressBook = (body) =>
{
	return utils.store('addressBook', body);
};

export const deleteAddressBook = (body) =>
{
	return utils.store('deleteAddressBook', body);
};

export const updateAddressBook = (body) =>
{
	return utils.update('addressBook', body);
};

export const updateProfile = (body) =>
{
	return utils.update('user/update-user', body);
};

export const changePasword = (body) =>
{
	return utils.store('user/change-password', body);
};

export const updateProfileImage = (body) =>
{
	return utils.storeFormData('user/saveprofilepic', body);
};

export const getusersList = (skip = 0, limit = 10, searchKey = '') =>
{
	let path = `user/userslist/${skip}/${limit}`;

	path += searchKey !== '' ? `?searchKey=${searchKey}` : '';

	return utils.fetch(path);
};

export const createUser = (body) =>
{
	return utils.store('user/add-user', body);
};

export const addPlan = (body) =>
{
	return utils.store('user/add-user-plan', body);
};

export const addCustomPlan = (body) =>
{
	return utils.store('addCustomPlan', body);
};

export const deleteUser = (body) =>
{
	return utils.store('user/delete-user', body);
};

export const updateUser = (userId, body) =>
{
	return utils.store(`user/edit-user?userId=${userId}`, body);
};

export const getCustomPlan = (search = '', page = 1, rowsPerPage = 10) =>
{
	let path = 'getCustomPlan';

	const queryParams = new URLSearchParams();

	if (search) queryParams.append('title', search);
	if (page) queryParams.append('page', page+1);
	if (rowsPerPage) queryParams.append('limit', rowsPerPage);

	// Append query parameters to the path
	if (queryParams.toString())
	{
		path += `?${queryParams.toString()}`;
	}

	return utils.fetch(path);
};
export const getActiveCustomPlans = () =>
{
	return utils.fetch('getActiveCustomPlans');
};

export const updateCustomPlan = (body) =>
{
	return utils.store('updateCustomPlan', body);
};
export const getCustomPlanDetails = (body) =>
{
	return utils.store('getCustomPlanDetails', body);
};
export const updateCustomPlanData = (body) =>
{
	return utils.store('updateCustomPlanData', body);
};